;(function () {
	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		let vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`,
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		menuLinks.forEach((link) => {
			link.addEventListener('mouseenter', (e) => {
				if (link.classList.contains('list-menu--megamenu')) {
					if (link.classList.contains('list-menu--tabs')) {
						const megaMenu = link.querySelector('.mega-menu')
						const headerMain = header.querySelector('.header')
						if (!megaMenu || !headerMain) return
						const linkPosition = link.getBoundingClientRect().x
						megaMenu.style.left = `${linkPosition}px`
					}
					link.classList.add('list-menu--megamenu-visible')
					if (
						header.classList.contains('color-background-3') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.remove('color-background-3')
					}

					menuLinks.forEach((el) => {
						if (el !== link) {
							el.classList.remove('list-menu--megamenu-visible')
						}
					})
				} else {
					menuLinks.forEach((el) => {
						el.classList.remove('list-menu--megamenu-visible')
					})
				}
			})
		})
		menu.addEventListener('mouseleave', (e) => {
			menuLinks.forEach((link) => {
				link.classList.remove('list-menu--megamenu-visible')
			})
		})

		document.body.addEventListener('mousedown', function () {
			document.body.classList.add('mouse-focus')
		})

		document.body.addEventListener('keydown', function (e) {
			if (e.key === 'Tab') {
				document.body.classList.remove('mouse-focus')
			}
		})

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-3') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.remove('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-1') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.add('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		header.addEventListener('mouseenter', addBackground)

		header.addEventListener('focus', addBackground)

		header.addEventListener('focusin', addBackground)

		header.addEventListener('mouseleave', removeBackground)

		header.addEventListener('focusout', removeBackground)

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector('.mega-menu__list-item--children')
			const megaMenuLinks = document.querySelectorAll('.mega-menu__list-item')
			const setSiblingOpacity = (link, enabled) => {
				Array.from(link.parentElement?.children || []).forEach((sibling) => {
					if (sibling !== link && sibling.classList.contains('mega-menu__list-item')) {
						sibling.classList.toggle('mega-menu__list-item--opacity', enabled)
					}
				})
			}
			const activateLink = (link) => {
				megaMenuLinkWithSubmenu?.classList.remove('mega-menu__list-item--visible')
				link.classList.remove('mega-menu__list-item--opacity')
				setSiblingOpacity(link, true)
			}
			const resetLink = (link) => setSiblingOpacity(link, false)

			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add('mega-menu__list-item--opacity')
				})
				megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--opacity')
				megaMenuLinkWithSubmenu.classList.add('mega-menu__list-item--visible')
			}

			megaMenuLinks.forEach((link) => {
				if (link.dataset.sdMegaMenuBound === 'true') return
				link.dataset.sdMegaMenuBound = 'true'
				link.addEventListener('mouseenter', () => activateLink(link))
				link.addEventListener('mouseleave', () => resetLink(link))
				link.addEventListener('focusin', () => activateLink(link))
				link.addEventListener('focusout', () => resetLink(link))
			})
		}

		const megaMenuSublinks = () => {
			const sublinks = document.querySelectorAll('.mega-menu--list .mega-menu__submenu-item')
			const relatedSublinks = (link) => {
				const parent = link.parentElement
				if (!parent?.parentElement) return []
				return Array.from(parent.parentElement.children)
					.filter((sibling) => sibling !== parent)
					.flatMap((sibling) => Array.from(sibling.querySelectorAll('.mega-menu__submenu-item')))
			}

			sublinks.forEach((link) => {
				if (link.dataset.sdMegaSubmenuBound === 'true') return
				link.dataset.sdMegaSubmenuBound = 'true'
				const activate = () => {
					link.classList.remove('mega-menu__submenu-item--opacity')
					relatedSublinks(link).forEach((sibling) => sibling.classList.add('mega-menu__submenu-item--opacity'))
				}
				const reset = () => {
					relatedSublinks(link).forEach((sibling) => sibling.classList.remove('mega-menu__submenu-item--opacity'))
				}
				link.addEventListener('mouseenter', activate)
				link.addEventListener('mouseleave', reset)
				link.addEventListener('focusin', activate)
				link.addEventListener('focusout', reset)
			})
		}

		const megaMenuTabs = () => {
			const tabWrappers = document.querySelectorAll('.mega-menu__tab-wrapper')
			document.querySelector('.mega-menu__tab-wrapper > * .mega-menu__tab-wrapper')
				?.classList.add('mega-menu__tab-wrapper--active')

			tabWrappers.forEach((wrapper) => {
				if (wrapper.dataset.sdMegaTabBound === 'true') return
				wrapper.dataset.sdMegaTabBound = 'true'
				const activate = () => {
					tabWrappers.forEach((tab) => tab.classList.remove('mega-menu__tab-wrapper--active'))
					wrapper.classList.add('mega-menu__tab-wrapper--active')
				}
				wrapper.addEventListener('mouseenter', activate)
				wrapper.addEventListener('focusin', activate)
			})
		}

		megaMenuListLinks()
		megaMenuSublinks()
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
			!main.querySelectorAll('.shopify-section')[0]?.classList.contains('not-margin')
		) {
			header.classList.add('color-background-1', 'color-background-3')
			if (breadcrumbs) {
				breadcrumbs.classList.add('color-background-3')
			}
		}
	}

	header()

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
})()
